import { unwrap, type HiveClient } from '@hive/api';
import type { HelpSource } from '@hive/ui';

/**
 * Ajuda da plataforma vinda do núcleo (`/api/v1/help/**`, HU-017/018/019): manual nos três
 * idiomas, contexto da tela e do passo do assistente, busca e perguntas sem IA.
 */
export function createHelpSource(api: HiveClient): HelpSource {
  return {
    async context({ screen, wizard, step, lang }) {
      const r = await unwrap(api.GET('/api/v1/help/context', { params: { query: { screen, wizard, step, lang } } }));
      return { article: r.article, stepText: r.stepText };
    },
    async search({ q, screen, lang, signal }) {
      return unwrap(api.GET('/api/v1/help/search', { params: { query: { q, screen, lang } }, signal }));
    },
    async article({ id, lang }) {
      return unwrap(api.GET('/api/v1/help/articles/{id}', { params: { path: { id }, query: { lang } } }));
    },
    async ask({ question, screen, lang, step }) {
      // Assistente com IA (HU-1111): com a IA desligada, devolve as seções do manual como o assistente do F0, com o motivo.
      try {
        const a = await unwrap(api.POST('/api/v1/help/assistant', { body: { question, screen, step, lang } }));
        const sections = (a.sections ?? []).map((x) => ({ id: x.id, title: x.ref ? `[${x.ref}] ${x.title ?? ''}` : x.title, anchor: x.anchor }));
        const wizard = typeof a.prefill?.wizard === 'string' ? a.prefill.wizard : undefined;
        return { answered: !!a.aiUsed || sections.length > 0, aiUsed: a.aiUsed, answer: a.answer, reason: a.reason, sections, suggestedWizard: wizard };
      } catch {
        const a = await unwrap(api.POST('/api/v1/help/ask', { body: { question, screen, lang } }));
        return { answered: a.answered, sections: a.sections, suggestedWizard: a.suggestedWizard, support: a.support };
      }
    },
  };
}
